import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class GarageGroundFloor extends AbstractProductType {

  name = 'garage_ground_floor'
  title = 'Garage Ground Floor'

  format = ProductTypeFormat.Indoor

}
